import React from "react"

const ContentTable = ({ ingredient, ths, tableRows, type }) => {
  return (
    <div className="table-container">
      <h3>{ingredient}</h3>
      <table className="content-table">
        <thead>
          <tr>
            <th>{ths.th1}</th>
            <th>{ths.th2}</th>
          </tr>
        </thead>
        <tbody>
          {tableRows.map((row, index) => (
            <tr key={index}>
              <td>{row.label}</td>
              <td>{`${row.ratio} ${type === "solid" ? "g" : "ml"}`}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
export default ContentTable
